import Onboarding from "@/components/ui/onboarding";
import { locationTrackingService } from "@/lib/services/location-tracking";
import { router } from "expo-router";
import React from "react";

export default function OnboardingLocation() {
  const handleBack = () => {
    router.back();
  };

  const handleNext = async () => {
    const status = await locationTrackingService.requestPermissions();
    if (!status) {
      console.log("Location permission denied");
    }
    router.push("/onboarding/notifications");
  };

  return (
    <Onboarding
      image={require("@/assets/images/onboarding/location.png")}
      title="Track your recovery"
      description="Auto Transporter UK collects location data to enable real-time vehicle tracking and estimated arrival times for your recovery, even when the app is closed or not in use."
      buttonText="Next"
      onButtonPress={handleNext}
      onBackPress={handleBack}
      step={2}
      totalSteps={3}
    />
  );
}
